<script setup>
import { onMounted, onUnmounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import UserPermissionsTableVue from '../../components/UserPermissionsTable.vue'
import SetPermissionsForm from '../../components/SetPermissionsForm.vue'
import RegisterLink from '../../components/RegisterLink.vue'
import { config } from '@/lib/helpers/config.helpers'

const route = useRoute()
const id = route.params.id
const { dispatch, commit, getters } = useStore()

const getRegisterUrl = (code) => {
  return `${config.identityAppUrl}/auth/registration?app=agency&invitation_code=${code}`
}

onMounted(async () => {
  await dispatch('clients/fetchData', id)
  dispatch('stores/findUsers', '')
})

const client = computed(() => getters['clients/clientUser'])
const clientUsers = computed(() => getters['clients/clientUsers'])
const loading = computed(() => getters['clients/loading'])
const permissionsList = computed(() => getters['clients/permissionsList'])
const permissions = computed(() => getters['clients/permissions'])
const registerLinks = computed(() => getters['clients/registerLinks'])
const error = computed(() => getters['clients/error'])
const success = computed(() => getters['clients/success'])
const usersList = computed(() => getters['stores/usersList'])
const registerLink = computed(() => getters['stores/registerLink'])
const userEmail = computed(() => getters['stores/userEmail'])

const autoCompleteUpdate = (value) => {
  dispatch('stores/updateUsersList', { path: 'value', value })
  dispatch('stores/findUsers', value)
}

onUnmounted(() => {
  commit('clients/update', {
    path: 'clientUser',
    value: [],
  })
})
</script>

<template>
  <div v-if="loading" class="spinner-container">
    <div class="spinner"></div>
  </div>
  <div v-else class="page">
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="success" class="success">{{ success }}</div>
    <h2>Client {{ client.name }} User Permissions</h2>
    <UserPermissionsTableVue
      :id="id"
      :users="clientUsers"
      type="client"
      :update-user-permission="(args) => commit('clients/update', args)"
      :on-save="(args) => dispatch('clients/updatePermission', args)"
      :on-delete="(args) => dispatch('clients/deletePermission', args)"
      :permissions-list="permissionsList"
    />
    <div>
      <h2>Set Permissions</h2>
      <SetPermissionsForm
        :id="id"
        :auto-complete-update="autoCompleteUpdate"
        :auto-complete-suggestions="usersList.suggestions"
        :update-selected-user="(args) => dispatch('stores/updateUsersList', args)"
        :value="usersList.value"
        :selected-user="usersList.selected"
        :update-permission="(args) => commit('clients/update', args)"
        :create-permissions="(args) => dispatch('clients/createPermission', args)"
        :create-register-link="(args) => dispatch('clients/createRegisterLink', args)"
        :checkable-permissions="permissions"
        :permissions-list="permissionsList"
        :register-link="registerLink"
        :user-email="userEmail"
      />
    </div>
    <div>
      <h2>Register Links</h2>
      <div v-if="registerLinks.length">
        <RegisterLink
          v-for="link in registerLinks"
          :key="link.code"
          :url="getRegisterUrl(link.code)"
          :email="link.email"
          :hide="link.hide?.join(', ') || ''"
        />
      </div>
      <div v-else class="info">There are no register links for this Agency</div>
    </div>
  </div>
</template>
